exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".input-search {\n  max-width: 300px;\n  min-width: 150px;\n  float: right;\n}\n", ""]);

// exports
